import {
  useEffect,
  useRef,
  useState
} from 'react'
import { Stack } from '@chakra-ui/react'
import { CreateComment } from 'components/Notifications/CommunityBlogs/Comments/CreateComment'
import { CommentsForPost } from 'components/Notifications/CommunityBlogs/Comments/CommentsForPost'
import { COLORS } from 'utils/styles'
import { SUCCEEDED } from 'utils/constants'

export const Comments = ({
  activeProfile,
  comments,
  getCommentsStatus,
  postCommentsStatus,
  putCommentsStatus,
  blogParent,
  blogRepostData,
  commentsOption,
  widen
}) => {
  const stickyHeaderRef = useRef(null)
  const [editCommentData, setEditCommentData] = useState({})
  const [
    stickyHeaderHeight,
    setStickyHeaderHeight
  ] = useState(0)

  const parentData = blogRepostData?.length ? blogRepostData?.at(-1) : blogParent?.at(-1)

  const handleMinHeight = () => {
    let wholeParent = document.querySelector(`#blog-repost-panel-${blogRepostData?.at(-1)?.id}`)
    const minusToHeight = getCommentsStatus === SUCCEEDED ? 39 : 10

    if (!blogParent.length) {
      return '100svh'
    }

    if (wholeParent) {
      return wholeParent?.offsetHeight - stickyHeaderHeight - minusToHeight
    }

    wholeParent = document.querySelector('#blog-panel')
    if (wholeParent) {
      return wholeParent?.offsetHeight - stickyHeaderHeight - minusToHeight
    }

    wholeParent = document.querySelector('.leaflet-popup-content')
    if (wholeParent) {
      return wholeParent?.offsetHeight - stickyHeaderHeight - minusToHeight
    }

    return '100svh'
  }

  useEffect(() => {
    const el = document.querySelector(
      blogRepostData?.length
        ? `#blog-repost-panel-${blogRepostData?.at(-1)?.id} #stickyHeader${blogRepostData?.at(-1)?.id}`
        : `#stickyHeader${blogParent.at(0)?.id}`
    )

    if (!el) {
      return false
    }

    stickyHeaderRef.current = el
    const updateHeight = () => {
      setStickyHeaderHeight(el.offsetHeight)
    }

    updateHeight()

    const observer = new ResizeObserver(updateHeight)
    observer.observe(el)

    return () => observer.disconnect()
  }, [blogParent, blogRepostData, widen])

  return (
    <Stack
      key={parentData?.comment_id ?? parentData?.id}
      margin="-15px 0"
      padding="20px 5px 10px 5px"
      background={COLORS.darkGray}
      minHeight={handleMinHeight()}
    >
      <Stack overflow="hidden">
        {
          getCommentsStatus === SUCCEEDED || comments.length
            ? (
              <CreateComment
                activeProfile={activeProfile}
                blogParent={blogParent}
                getCommentsStatus={getCommentsStatus}
                type={commentsOption.type}
                postCommentsStatus={postCommentsStatus}
                putCommentsStatus={putCommentsStatus}
                editCommentData={editCommentData}
                setEditCommentData={setEditCommentData}
              />
            ) : ''
        }

        <CommentsForPost
          activeProfile={activeProfile}
          blogRepostData={blogRepostData}
          comments={comments}
          getCommentsStatus={getCommentsStatus}
          setEditCommentData={setEditCommentData}
          commentsOption={commentsOption}
          blogParent={blogParent}
          widen={widen}
        />
      </Stack>
    </Stack>
  )
}
